module.exports = __webpack_public_path__ + "media/application/images/svgs/corner-right-up-1dea7326105c9040282e52bcec887bab.svg";